import { ReactComponent as Aire } from "./Aire-acondicionado.svg";
import { ReactComponent as AireV2 } from "./aire_Acondicionado.svg";
import { ReactComponent as Bar } from "./Mini-bar.svg";
import { ReactComponent as BarV2 } from "./bar.svg";
import { ReactComponent as Ciudad } from "./Ciudad.svg";
import { ReactComponent as Cultura } from "./Cultura.svg";
import { ReactComponent as Diversion } from "./Diversion.svg";
import { ReactComponent as Playa } from "./Playa.svg";
import { ReactComponent as Receptivos } from "./Receptivos.svg";
import { ReactComponent as MiniMarket } from "./miniMarket.svg";
import { ReactComponent as Parqueadero } from "./parqueadero.svg";
import { ReactComponent as PetFriendly } from "./pet_friendly.svg";
import { ReactComponent as Piscina } from "./piscina.svg";
import { ReactComponent as Recepcion24h } from "./recepcion_24_horas.svg";
import { ReactComponent as Restaurante } from "./restaurante.svg";
import { ReactComponent as Selva } from "./Selva.svg";
import { ReactComponent as TV } from "./TV.svg";
import { ReactComponent as Compras } from "./Compras.svg";

export const ICONS_MAP = {
  "Aire-acondicionado.svg": Aire,
  "aire-acondicionado.svg": AireV2,
  "Mini-bar.svg": Bar,
  "bar.svg": BarV2,
  "Ciudad.svg": Ciudad,
  "Cultura.svg": Cultura,
  "Diversion.svg": Diversion,
  "Playa.svg": Playa,
  "Receptivos.svg": Receptivos,
  "miniMarket.svg": MiniMarket,
  "parqueadero.svg": Parqueadero,
  "pet_friendly.svg": PetFriendly,
  "piscina.svg": Piscina,
  "recepcion_24_horas.svg": Recepcion24h,
  "restaurante.svg": Restaurante,
  "Selva.svg": Selva,
  "TV.svg": TV,
  "Compras.svg": Compras,
};
